



















import { Component, Vue, Provide } from "vue-property-decorator";
import request from "@/api/index";
import Columns from "@/components/Columns.vue";
import ThingsAround from "@/components/ThingsAround.vue";
import { ColumnsConfig } from "../common/BaseConfig";
import { TempletCode } from "@/common/BaseConfig";
@Component({
  components: {
    Columns,
    ThingsAround
  }
})
export default class Home extends Vue {
  private columnList: object[] = [];
  mounted() {
    this.getColumns();
  }
  getColumns() {
    request.getColumns(ColumnsConfig.智慧社区).then(result => {
      if (result.code === 0) {
        this.columnList = result.data.dataList.filter(
          item => item.name != "社区消息"
        );
      }
    });
  }

  toService() {
    const data: any = this.columnList.filter(
      (item: any) => item.templetCode === TempletCode.NOMAL_LINK
    );
    this.$router.push(`/iframe?title=${data[0].name}`);
  }
}
